import React, { useEffect, useState } from "react";

import "./LoadingDots.scss";

interface LoadingDotsProps {
	text: string;
	interval?: number;
}

const LoadingDots: React.FC<LoadingDotsProps> = ({ text, interval = 500 }) => {
	const [dots, setDots] = useState("."); // Start with one dot

	useEffect(() => {
		const timer = setInterval(() => {
			setDots((prevDots) => {
				if (prevDots === ".") return "..";
				if (prevDots === "..") return "...";

				return ".";
			});
		}, interval);

		return () => clearInterval(timer);
	}, [interval]);

	return (
		<span>
			{text}
			<span className="LoadingDots">{dots}</span>
		</span>
	);
};

export default LoadingDots;
